import { render, staticRenderFns } from "./SysCourse.vue?vue&type=template&id=67f2bc78&scoped=true"
import script from "./SysCourse.vue?vue&type=script&lang=js"
export * from "./SysCourse.vue?vue&type=script&lang=js"
import style0 from "./SysCourse.vue?vue&type=style&index=0&id=67f2bc78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f2bc78",
  null
  
)

export default component.exports